import { FC, useState } from "react";
import CustomPopup from "../../../../custom-components/CustomPopup";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import { UserResetPasswordFirstStep, UserResetPasswordSecondStep } from "../../../../domain/models/dto/UserDTO";
import CustomInput from "../../../../custom-components/form-inputs/CustomInput";
import CustomError from "../../../../custom-components/form-inputs/CustomError";
import { userResetPasswordSecondStepFields } from "../../../../validation-schemas/user-schemas/UserResetPasswordSchema";

interface ResetPasswordSecondStepProps {
    firstStepForm: FormikProps<UserResetPasswordFirstStep>;
    secondStepForm: FormikProps<UserResetPasswordSecondStep>;
    error: string;
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
}

const ResetPasswordSecondStep: FC<ResetPasswordSecondStepProps> = (props) => {
    const [isCodeSentVisible, setIsCodeSentVisible] = useState(false);
    const { t } = useTranslation();
    const sendCodeAgainHandler = () => {
        props.firstStepForm.handleSubmit();
        setIsCodeSentVisible(true);
    };

    return (
        <CustomPopup
            isVisible={props.isVisible}
            setIsVisible={props.setIsVisible}
            wrapClassName="dmin2:min-w-[1062px] di6:min-w-[800px] ti6:min-w-[650px] ti7:min-w-[362px] tmax4:min-w-[362px]"
            title={t("resetPassword.resettingProcedure")}
            titleClassName="my-8 dmax2:my-6"
            confirmTitle={t("common.next")}
            confirmHandler={props.secondStepForm.handleSubmit}
            confirmButtonClassName="w-[193px] dmax2:w-[133px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
        >
            <div className="relative flex flex-col items-center justify-center w-[410px] dmax2:w-[330px]">
                <div className="text-center mb-6 dmax2:mb-5">
                    <p className="H20 dmax2:H16 text-textFaded">
                        {t("resetPassword.resetSecondStepRule")}{" "}
                        <span className="H20B dmax2:H16B text-textWhite">{props.firstStepForm.values.email}</span>
                    </p>
                </div>
                <CustomInput
                    form={props.secondStepForm}
                    name="recoveryCode"
                    fields={userResetPasswordSecondStepFields}
                    className="w-[300px] dmax2:w-[240px] h-[63px] dmax2:h-[45px] mb-3 dmax2:mb-2 text-center"
                />
                <div
                    onClick={sendCodeAgainHandler}
                    className="H20B dmax2:H16B text-textWhite mt-8 dmax2:mt-6 cursor-pointer"
                >
                    {t("resetPassword.receiveCodeAgain")}
                </div>
                {isCodeSentVisible && (
                    <p className="H14 dmax2:H12 text-textWhite mt-5 dmax2:mt-3">{t("resetPassword.codeWasSend")}</p>
                )}
                <CustomError
                    form={props.secondStepForm}
                    errorKey={props.error}
                    className="mt-6 dmax2:mt-5 text-center"
                />
            </div>
        </CustomPopup>
    );
};

export default ResetPasswordSecondStep;
